export var ResetPasswordErrorCode;
(function (ResetPasswordErrorCode) {
    ResetPasswordErrorCode["INVALID_TOKEN"] = "INVALID_TOKEN";
    ResetPasswordErrorCode["INVALID_PASSWORD"] = "INVALID_PASSWORD";
    ResetPasswordErrorCode["USER_UPDATE_FAILED"] = "USER_UPDATE_FAILED";
    ResetPasswordErrorCode["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
})(ResetPasswordErrorCode || (ResetPasswordErrorCode = {}));
//# sourceMappingURL=resetPassword.js.map